import React from 'react';
import CustomTextField, { CustomTextFieldProp } from '@/components/common/CustomTextField';
import CustomAutocomplete, { CustomAutocompleteProp } from '@/components/common/CustomAutocomplete';
import CustomSelect, { CustomSelectProp } from '@/components/common/CustomSelect';
import CustomColorPicker, { CustomColorPickerProp } from '@/components/common/CustomColorPicker';
import CustomCheckBox, { CustomCheckBoxProp } from './CustomCheckBox';
import CustomRadioGroup, { CustomRadioGroupProp } from './CustomRadioGroup';

export type HookFormControlsProps =
  | CustomTextFieldProp
  | CustomAutocompleteProp
  | CustomSelectProp
  | CustomColorPickerProp
  | CustomCheckBoxProp
  | CustomRadioGroupProp;

const HookFormControls: React.FC<HookFormControlsProps> = (prop) => {
  if (prop.type === 'text') {
    return <CustomTextField {...prop}></CustomTextField>;
  } else if (prop.type === 'select') {
    return <CustomSelect {...prop}></CustomSelect>;
  } else if (prop.type === 'autocomplete') {
    return <CustomAutocomplete {...prop}></CustomAutocomplete>;
  } else if (prop.type === 'color') {
    return <CustomColorPicker {...prop}></CustomColorPicker>;
  } else if (prop.type === 'checkbox') {
    return <CustomCheckBox {...prop}></CustomCheckBox>;
  } else if (prop.type === 'radioGroup') {
    return <CustomRadioGroup {...prop}></CustomRadioGroup>;
  } else {
    return <CustomTextField {...prop}></CustomTextField>;
  }
};

export default HookFormControls;
